export default {
  'ko-kr': {
    flag: 'korea',
    shopManagement: '매장관리자',
    estimatedPaymentAmount: '결제 예상금액',
    common: {
      search: '검색',
    },
    footer: {
      address: '서울특별시 강남구 논현로 721, 3층(논현동, 에르고슬립빌딩)',
      customerService: '고객센터 1577-0564',
      companyNameKorean: '주식회사 비원소프트',
      companyCeoName: '대표이사: 최석웅',
      businessLicenseNumberText: '사업자등록번호',
      businessLicenseNumber: '816-87-01138',
      companyNameEnglish: 'B1SOFT., LTD B1SOFT',
    },
    currency: {
      kr: {
        text: 'KRW',
        symbol: '₩',
      },
      us: {
        text: 'USD',
        symbol: '$',
      },
    },
    grade: {
      Rookie: '루키',
      Beginner: '비기너',
      Amateur: '아마추어',
      SemiPro: '세미프로',
      Pro: '프로',
      TourPro: '투어프로',
      Challenger: '챌린저',
    },
    gender: {
      man: '남자',
      woman: '여자',
      unLimit: '제한없음',
    },
    menu: {
      shopInfoManagement: '매장 정보 관리',
      gameRoundOptionOptionManagement: '게임 옵션 관리',
      drivingRangeOptionOptionManagement: '연습장 옵션 관리',
      realtimeControlOptionManagement: '실시간 제어 옵션 관리',
      agreement: '약관',
      signOut: '로그아웃',
    },
    signIn: {
      id: '아이디',
      password: '비밀번호',
      forgotId: '아이디 찾기',
      forgotPassword: '비밀번호 찾기',
      rememberMe: '로그인 상태 유지',
      buttonSignIn: '로그인',
      cookie: '쿠키 삭제',
      cookieMessage: '쿠키를 삭제 하였습니다.',

      fail: '로그인 실패. 다시 시도해주세요.',
    },
    notification: {
      title: '알림',
      no: '번호',
      roomName: '타석이름',
      callTime: '호출시간',
      message: '메시지',
      confirm: '확인',
      noNotificationMSG: '호출된 알림 메시지가 없습니다.',
      
      billing_automatic_payment_failed: '[K-Golf 자동결제 실패 안내] K-Golf 자동결제가 실패하였습니다. ${payment_date} 일 이후 타석에서 연습장을 제외한 다른 컨텐츠를 이용 하실 수 없습니다. 자동결제 미납분 결제 및 기타 사항에 대해서는 고객센터에 문의하시기 바랍니다. [고객센터] ${customer_center_number}',
      billing_automatic_payment_guide: '[K-Golf 자동결제 안내] K-Golf 자동결제가 ${payment_date} 에 예정입니다. 계좌 상태를 확인 하시기 바랍니다. 자동결제 예정일에 결제가 완료되지 않으면, 자동결제일 이후 타석에서 연습장을 제외한 다른 컨텐츠를 이용 하실 수 없습니다. [고객센터] ${customer_center_number}',
      billing_automatic_payment_success: '[K-Golf 자동결제 완료 안내] K-Golf 자동결제가 완료되었습니다.',
      billing_content_restrictions_notice: '[K-Golf 이용정지 안내] K-Golf 결제일 이내 결제가 진행되지 않아,${payment_date} 이후 타석에서 연습장을 제외한 다른 컨텐츠를 이용 하실 수 없습니다. 미납금액 결제 및 기타사항 에 대해서는 고객센터에 문의하시기 바랍니다. [고객센터] ${customer_center_number}',
      billing_manual_payment_guide: '[K-Golf 일반결제 기간 안내] ${start_date} ~ ${end_date} 까지 (${diff_day}일간) 해당 기간안에 결제를 진행하지 않으면, 결제일 이후 타석에서 연습장을 제외한 다른 컨텐츠를 이용 하실 수 없습니다. [고객센터] ${customer_center_number}',
      
      game_client_additional_access_game_round_approval_failed: '${client_name}의 라운드 추가 이용 승인 명령 전송이 실패 하였습니다.',
      game_client_additional_access_game_round_request: '${client_name}에서 라운드 추가 이용을 요청 하였습니다.',
      game_client_additional_access_game_round_request_reject: '${client_name}의 라운드 추가이용 요청을 거절 하였습니다.',
      
      game_client_cancel_shot_failed: '${client_name}의 마지막 샷 취소에 실패했습니다.',
      game_client_cancel_shot_failed_2: '플레이어의 샷 취소 횟수를 모두 사용했습니다.',
      game_client_cancel_shot_failed_3: '게임이 진행 중입니다. 샷 취소에 실패했습니다.',
      game_client_cancel_shot_failed_4: '취소 가능한 샷이 없습니다.',
      game_client_cancel_shot_success: '${client_name}의 마지막 샷 취소를 성공했습니다.',
      
      game_client_extended_wait_success: '${client_name}이 대기상태로 변경 되었습니다.',
      
      game_client_force_disconnection_failed: '${client_name}의 연결 강제 해제 명령 전송이 실패 하였습니다.',
      game_client_force_disconnection_success: '${client_name}의 연결 강제 해제가 성공적으로 완료되었습니다.',
      
      game_client_guest_login_failed: '${client_name}에 게스트 로그인이 명령 전송이 실패 하였습니다.',
      game_client_guest_login_success: '${client_name}에 게스트 로그인이 성공 하였습니다.',
      
      game_client_limit_change_failed: '${client_name}의 제어옵션 변경 내역 전송이 실패 하였습니다.',
      game_client_limit_change_success: '${client_name}의 제어옵션이 변경되었습니다.',
      
      game_client_lock_failed: '${client_name}에 잠금 명령 전송이 실패 하였습니다.',
      game_client_lock_success: '${client_name}이 잠금상태로 변경 되었습니다.',
      
      game_client_player_count_change_failed: '${client_name}의 이용인원 변경 명령 전송이 실패 하였습니다.',
      game_client_player_count_change_request_reject: '${client_name}에서 이용인원 제한 수 변경 요청을 거절 하였습니다.',
      game_client_player_count_change_success: '${client_name}의 이용인원이 ${n}명에서 ${player_count}명으로 변경 되었습니다.',
      
      game_client_reset_mulligan_failed: '${client_name}의 멀리건 횟수 초기화에 실패했습니다.',
      game_client_reset_mulligan_success: '${client_name}의 멀리건 횟수 초기화에 성공했습니다.',
      
      game_client_shop_manager_call_request: '${client_name}에서 매장관리자를 호출 하였습니다.',
      
      game_client_time_extension_failed: '${client_name}의 이용시간 추가 명령 전송이 실패 하였습니다.',
      game_client_time_extension_request: '${client_name}에서 이용시간 연장을 요청 하였습니다.',
      game_client_time_extension_request_reject: '${client_name}의 이용시간 연장 요청을 거절 하였습니다.',
      game_client_time_extension_success_1: '${client_name}의 이용시간이 ${add_time}분 연장되었습니다.',
      
      game_client_unlock_failed: '${client_name}에 잠금해제 명령 전송이 실패 하였습니다.',
      game_client_unlock_success: '${client_name}의 잠금이 해제 되었습니다.',
      
      game_client_user_login_failed: '${client_name}의 사용자 로그인이 명령 전송이 실패 하였습니다.',
      game_client_user_login_success: '${client_name}의 사용자 로그인이 성공하였습니다.',
      
      kms_notice: '${title}',
      
      quit_game_client_failed: '${client_name}의 종료 요청에 실패 했습니다.',
      quit_game_client_success: '${client_name}의 종료 요청에 성공 했습니다.',
      
      run_game_client_failed: '${client_name}의 실행 요청에 실패 했습니다.',
      run_game_client_success: '${client_name}의 실행 요청에 성공 했습니다.'
    },
    dashboard: {
      content: '대한민국 대쉬보드',
    },
    gameHistory: {
      searchPeriod: '검색 기간',
      userNickname: '회원 닉네임',
      userNicknamePlaceholder: '닉네임을 입력해주세요.',
      search: '검색',
      gameType: '게임 타입',
      shopClient: '타석',
      all: '전체',
      gameHistoryStatistics: '게임 내역 통계',
      gameHistoryStatisticsNoticeText: '( 검색 기준에 따른 통계 정보 입니다. )',
      gameMode: '게임 모드',
      normalGame: '일반 게임',
      drivingRange: '연습장',
      swingDiagnosis: '스윙 진단',
      userType: '회원 구분',
      user: '회원',
      guest: '게스트',
      gender: '성별',
      male: '남성',
      female: '여성',
      times: '회',
      gameRoundList: '게임 라운드 목록',
      gameNumbers: '게임 번호',
      clientName: '타석명',
      numberPlayers: '플레이어 수',
      numberHolesCompleted: '완료 홀 수',
      startDate: '시작 시간',
      endDate: '종료 시간',
      more: '더보기',
      close: '접기',
      download: '다운로드',
      alert: {
        message1: '타석은 최소 1개는 선택되어 있어야 합니다.',
        message2: '게임 타입은 최소 1개는 선택되어 있어야 합니다.',
        message3: '기간은 최대 3개월까지만 선택할 수 있습니다.',
        message4: '검색 데이터 양에 따라 지연될 수 있습니다.\n진행하시겠습니까?',
        message5: 'No data',
      },
    },
    clientStatus: {
      sendMessage: '메세지 전송',
      statusInfo: '상태 정보',
      proceeding: '진행중',
      endUse: '이용 종료',
      blind: '잠금',
      lobby: '로비',
      clientOff: '클라이언트 꺼짐',
      course: '코스',
      playerCount: '플레이어 수',
      remainingTime: '남은시간',
      start: '시작',
      paymentType: '결제 방법',
      usageModeSetting: '이용 모드 설정',
      gameType: '게임 타입',
      usageTimeSetting: '이용 시간 설정',
      holeType: '홀 타입',
      drivingRangeTime: '연습 시간',
      noLimit: '제한없음',
      stroke: '게임',
      drivingRange: '연습',
      minutes: '분',
      lessThanMinute: '1분 미만',
      paymentProgress: '후불 진행중',
      peopleCount: '명',
      noDrivingRange: '없음',
      status: '상태',
      usageTime: '이용시간',
      usageCourse: '이용코스',
      usagePeopleCount: '사용인원',
      addGuest: '게스트 추가',
      extendedTime: '시간 연장',
      scorecard: '스코어카드',
      changeSetting: '설정 변경',
      resetMulligan: '멀리건 초기화',
      cancelShot: '샷 취소',
      bilnd: '잠금',
      currentHole: '현재 홀',
      sound : '알림음',
      clientType : '타석구분',
      popup: {
        close: '닫기',
        addGuest: {
          addGuest: '게스트 추가',
          guestNicknamePlaceholder: '게스트 닉네임을 입력해주세요.',
          cancel: '취소',
        },
        shotCancel: {
          confirmMessage: '${clientName} 타석의 마지막 샷을 취소합니다.',
          shotCancel: '확인',
          cancel: '취소',
        },
        sendMessage: {
          sendMessage: '메시지 전송',
          all: 'ALL',
          cancel: '취소',
          messagePlaceholder: '전송할 메시지 내용을 입력해 주세요.',
        },
        extendedTime: {
          extendedTime: '시간 연장',
          minutes: '분',
          addServiceTime: '서비스 시간 충전',
          cancel: '취소',
        },
        changeSetting: {
          changeSetting: '설정 변경',
          cancel: '취소',
        },
      },
      alert: {
        message1: '결제 방법을 선택해주세요.',
        message2: '이용 시간 설정을 선택해주세요.',
        message3: '이용 모드 설정을 선택해주세요.',
        message4: '게임 타입을 선택해주세요.',
        message5: '홀 타입을 선택해주세요.',
        message6: '플레이어 수를 선택해주세요.',
        message7: '연습 시간을 선택해주세요.',
        message8: '타석의 화면을 잠금 처리 하시겠습니까?',
        message9: '잠시 후 다시 시도해주시기 바랍니다.',
        message10: '현재 진행중인 게임의 멀리건을 초기화 하시겠습니까?',
        message11: '게임 라운드 ID 정보가 없으므로 멀리건 초기화를 요청할 수 없습니다.',
        message12: '타석 제어 설정을 변경하시겠습니까?',
        message13: '게임 라운드 설정을 변경하시겠습니까?',
        message14: '메시지를 전송할 타석을 선택해주세요.',
        message15: '메시지를 입력해주세요.',
        message16: '해당 타석은 후불이므로 시간을 연장할 수 없습니다.',
        message17: '연장할 시간을 다시 선택해주세요.',
        message18: '게스트 닉네임을 입력해주세요.',
        message19: '로그인 가능한 인원수가 부족하여 게스트 로그인 요청을 할 수 없습니다.',
        message20: '게임 라운드 ID 정보가 없으므로 샷취소를 요청할 수 없습니다.',

        message1000: '게임 라운드 설정 변경 기능은 준비 중입니다.',
      },
    },
    billing: {
      tossPay: {
        addressTitle: '배송지',
        clearAddressButton: '주소 초기화',
        clearAddressTooltip: '수령인/연락처는 유지하고 주소만 초기화',
        recipientPlaceholder: '수령인',
        phonePlaceholderKrw: '연락처 (예: 010-1234-5678)',
        phonePlaceholderIntl: '연락처 (국가번호 포함 가능)',
        postcode: '우편번호',
        searchAddressButton: '주소찾기',
        address1Krw: '기본주소',
        address2Krw: '상세주소 (동/호수 등)',
        address1Intl: 'Address line 1',
        searchHint: 'Search…',
        address2Intl: 'Address line 2 (Apt, Unit, etc.)',
        country: 'Country',
        city: 'City',
        state: 'State / Province / Region',
        postalIntl: 'Postal code / ZIP',
        saveNoteKrw: '※ 결제 시 배송지가 함께 저장됩니다.',
        saveNoteIntl: '※ Your shipping address will be saved with your payment.',
        fedexTitle: 'FedEx Account',
        fedexPlaceholder: 'FedEx 계정 번호를 입력하세요',
        fedexNote: '※ 착불(collect) 발송을 위해 필요합니다.',
        // ▼ 추가된 키
        fedexHelpTitle: 'FedEx 계정이 없으신가요?',
        fedexHelpDesc: '아래 링크를 통해 간단히 계정을 생성하실 수 있습니다.',
        fedexGlobalLink: 'FedEx 계정 생성 페이지 (글로벌)',
        fedexUSLink: 'FedEx 계정 생성 페이지 (미국 기준)',
        fedexGuideLink: '계정 생성 안내 (FAQ)',
        paymentMethodsTitle: '결제수단',
        agreeRequired: '결제 서비스 이용 약관 및 개인정보 처리 방침에 동의하셔야 합니다.',
        enterShipping: '배송지를 입력해 주세요.',
        enterFedex: 'FedEx Account를 입력해 주세요.',
        payNow: '결제하기',
        cardLabel: 'Credit Card',
        paypalLabel: 'PayPal',
        alipayLabel: 'Alipay',
      }
      ,
      paymentInfo: {
        ownerDefaultInfo: '매장주 기본 정보',
        shopName: '매장명',
        shopOwnerName: '매장주 이름',
        shopAddress: '매장 주소',
        shopAddressChangeNoticeText: '매장 주소 변경을 원하시는 경우 K-Golf 고객센터에 연락해 주시기 바랍니다.',
        receiveBillInfoChange: '명세서 정보 변경',
        receiveBillInfoChangeNoticeText: '매달 K-Golf 이용시 발생하는 요금에 대한 명세서를 수신',
        shopOwnerMobilePhone: '매장주 연락처',
        editButton: '수정하기',
        mobileBill: '모바일 명세서 (MMS)',
        mobileBillNoticeText: '매달 이용요금 명세서를 등록된 매장주 연락처로 발송합니다.',
        sendButton: '발송',
        shipsFirstDayEveryMonth: '매달 1일 발송',
        mobileBillNoAuth: '인증되지 않았습니다. 모바일 인증을 하지 않으면, 결제관련 명세서를 받을 수 없습니다.',
        shopOwnerEmail: '매장주 이메일',
        authenticateButton: '인증하기',
        emailBill: '이메일 명세서',
        emailBillNoticeText: '매달 이용요금 명세서를 등록된 매장주 이메일로 발송합니다.',
        emailBillNoAuth: '인증되지 않았습니다. 이메일 인증을 하지 않으면, 결제관련 명세서를 받을 수 없습니다.',
      },
      recurringPayment: {
        noRecurringPaumentServiceNoticeText1: '정기결제 서비스에 등록되어 있지 않은 매장입니다.',
        noRecurringPaumentServiceNoticeText2: '정기결제 관리는 정기결제 서비스가 등록되어야 열람이 가능 합니다.',
        agreementToUseRecurringPaymentService: '정기결제 서비스 이용 동의',
        guide: '정기결제서비스 등록가이드',
        whatIsRecurringPaymentService: '정기결제 서비스 란?',
        recurringPaymentServiceDescription:
          '본사 (주)케이골프에서 지정한 결제일에 매월 자동으로 결제금액을 출금하는 서비스입니다. 정기결제 서비스를 이용하는 경우에는 최대 결제금액의 2.0%의 요금 할인이 있습니다.',
        agreeTermsConditionsRecurringPayment: '정기결제 이용약관 동의',
        allAgreement: '전체 동의',
        required: '필수',
        termsOfRecurringPaymentService: '정기결제 서비스 이용 약관 동의',
        personalInformationProvidedThirdParties: '개인정보 제 3자 제공 동의',
        entrustingHandlingOfPersonalInformation: '개인정보 취급 위탁 동의',
        useAgreementButtonText: '정기결제 서비스 이용 약관 동의',
        useAgreementNoticeText: '정기결제 이용 약관에 동의해주시기 바랍니다.',
        recurringPaymentService: '정기결제 서비스',
        status: '상태',
        statusApplyingText: '신청중',
        statusUseText: '이용중',
        serviceStartDate: '서비스 시작일',
        automaticPaymentDueDate: '자동 결제 예정일',
        discountRate: '할인율',
        recurringPaymentServiceCancel: '정기결제 서비스 이용 취소',
        bankAccountRegistrationAndManagement: '계좌 등록 및 관리',
        bankAccount: '계좌',
        bankAccountNumber: '계좌 번호',
        bankAccountName: '계좌명',
        management: '관리',
        addBankAccount: '계좌 등록',
        deleteBankAccount: '계좌 삭제',
        noBankAccountNoticeText: '등록된 계좌가 없습니다.<br />우측의 계좌 등록 버튼을 눌러 계좌 등록을 진행하시기 바랍니다.',
        creditCardRegistrationAndManagement: '카드 등록 및 관리',
        creditCard: '카드',
        creditCardNumber: '카드 번호',
        noCreditCardNoticeText: '등록된 카드가 없습니다.<br />우측의 카드 등록 버튼을 눌러 카드 등록을 진행하시기 바랍니다.',
        addCreditCard: '카드 등록',
        deleteCreditCard: '카드 삭제',
        recurringPaymentNoticeText: '자동결제 서비스에 계좌 및 카드가 모두 등록되어 있는 경우 <strong>계좌를 우선</strong>으로 결제 서비스를 진행 합니다.<br />해당 계좌에 출금 가능 금액이 부족한 경우 신용카드로 결제를 시도합니다.',
      },
      paymentProgress: {
        text1: '결제정보를 확인하고 있습니다.',
        text2: '잠시만 기다려 주세요.',
      },
      paymentComplete: {
        text1: '결제 성공',
        text2: '(가상계좌 이용시 이체 확인 후 이용 가능합니다.)',
        buttonText: '완료',
      },
      paymentFail: {
        text1: '결제 실패',
        text2: '',
        buttonText: '닫기',
      },
      paymentCancel: {
        text1: '결제 취소',
        text2: '',
        buttonText: '닫기',
      },
      payment: {
        generalPayment: '일반 요금납부',
        prepayment: '결제 예정 금액 선결제',
        paymentUnpaidCharges: '미납 요금납부',

        chargesText: '납부하실 금액은 <span class="price">|charges|</span> <span style="font-size:26px;">|currency|</span> 입니다.',
        checkPaymentHistory: '납부 내역을 확인해주세요.',
        billingMonth: '청구월',
        amountBePaid: '납부하실 금액',
        details: '상세내역',
        choosePaymentMethod: '결제 방법을 선택해주세요.',
        realTimeAccountTransfer: '실시간 계좌이체',
        creditCardPayment: '신용카드 결제',

        tab1: {
          text1: '지금은 일반 요금납부가 가능한 기간이 아니거나,',
          text2: '납부할 금액이 존재하지 않습니다.',
          text3: '일반요금 납부 가능 기간',
          text4: '일반 요금납부는 매달 1일 부터 K-Golf 본사가 지정한 결제일 마감일 까지만 가능 합니다.',
          text5: '결제 마감일',
          text6: '일반 요금납부 가능기간',
          text7: '매달',
          text8: '일',
        },
        tab2: {
          text1: '지금은 선결제 가능한 기간이 아니거나,',
          text2: '결제할 금액이 존재하지 않습니다.',
          text3: '선결제 가능 기간',
          text4: '선결제는 매달 1일 부터 K-Golf 본사가 지정한 결제일의 전전날 까지만 가능 합니다.',
          text5: '결제 마감일',
          text6: '일반 요금납부 가능기간',
          text7: '매달',
          text8: '일',
        },
        tab3: {
          text1: '미납 금액이 존재 하지 않습니다.',
          text2: '미납금액은 K-Golf 본사가 지정한 결제일 이후 부터 미납금액 결제가 가능 합니다.',
          text3: 'K-Golf 결제일',
          text4: '매달',
          text5: '일',
          text6: '선결제 납부 가능 기간',
          text7: '선결제는 매달 1일 부터 K-Golf 본사가 지정한 결제일의 전전날 까지만 가능 합니다.',
          text8: '결제 마감일',
          text9: '선결제 가능 기간',
        },
      },
      bills: {
        monthPaymentAmount: '|month| 결제 금액',
        usagePeriod: '이용기간',
        clientName: '타석 이름',
        usageAmount: '이용금액',
        discountAmount: '할인금액',
        paymentAmount: '납부금액',
        contentPlan: '콘텐츠 상품',
        coursePlan: '코스 상품',
        minutes: '분',
        course: '코스',
        totalCharges: '소계',
        count: '개',
        coutseUnlimit: '제한없음',
        vat: '부가세',
        currentMonthTotalCharges: '이번달 요금 합계',
        totalAmount: '총 청구요금',
      },
      paymentHistory: {
        text1: '납부 내역은 최대 12개월 전 까지의 기록만 조회가 가능 합니다. 그 이전 내역을 원하시는 경우 본사에 연락 하시기 바랍니다.',
        billMonth: '명세서 발급월',
        charges: '청구 금액',
        paymentStatus: '납부 상태',
        paymentSuccess: '납부완료',
        unpayment: '미납부',
      },
      itemPaymentHistory: {
        info01: '영수증 확인은 아이템 구매시 입력한 e-mail에서 확인 하세요.',
        info02: '환불 요청은 고객센터에 문의 주세요.',
        date: '구매 일자',
        orderNumber: '주문 넘버',
        purchaseItem: '구매 항목',
        charges: '결제 금액',
        paymentMethod: '결제 수단',
        materialCode: '자재 코드',
        quantity:     '수량',
        // paymentMethodMap 대체용
        paymentMethods: {
          CA:              '신용카드',
          AccountTransfer: '계좌이체',
          PZ:              '페이결제',
          EASYPAY:         '간편결제',
        },
        // statusMap 대체용
        statuses: {
          0: '상품준비중',
          1: '발송완료',
          2: '배송완료',
          3: '환불',
        }
      },
    },
    customerService: {
      notice: {
        postType: '분류',
        searchPlaceholder: '제목 + 내용',
        postTitle: '제목',
        registrationDate: '등록일자',
        attachments: '첨부파일',
        moveListButtonText: '목록',
        postTypeCode: {
          notice: '공지사항',
          update: '업데이트',
          event: '이벤트',
        },
      },
      qna: {
        test: 'test',
      },
    },
    edit: {
      shopInfoSetting: {
        clientTypeAlert: '타석타입은 무조건 하나 이상 체크되어야 합니다.',

        shopInfo: '매장 정보',
        shopName: '매장명',
        shopPhoneNumber: '매장 전화번호',
        shopAddress: '매장 주소',
        shopOwnerName: '매장주 이름',
        shopOwnerMobilePhone: '매장주 전화번호',

        shopSalesInfo: '매장 영업 정보',
        operatingTime: '운영시간',
        operatingTimePlaceholder: '예시) \n평일 AM 08:00 ~ PM:12:00 \n주말/공휴일 AM 06:00 ~ PM 12:00',
        screen: '스크린',
        practiceRange: '연습장',
        lesson: '레슨',
        convenientFacilities: '편의시설',
        swingPlate: '스윙플레이트',
        leftHanded: '양타',
        parking: '주차',
        equipmentStorage: '장비보관',
        proLesson: '프로레슨',
        fee: '이용요금',
        feePlaceholder: '예시) \n자세한 요금은 매장에 문의하세요',
        storeView: '매장전경',
        parkingNotice: '주차안내',
        parkingPlaceholder: '예시) \n무료주차 (빌딩 주차장 이용)',
        storeIntroduce: '매장소개',
        storeIntroducePlaceholder: '예시) \n누구나 편안하게 골프를 즐길 수 있도록 노력하겠습니다. \n찾아주셔서 늘 감사합니다.',
        clientList: '타석 리스트',
        clientName: '타석 이름',
        clientOrder: '타석 순서',
        clientInfo: '타석 정보',
        clientType: '타석 타입',
        cancel: '취소',
        saveChanges: '변경내용 저장',
      },
      shopGameRoundOptionSetting: {
        title: '게임 옵션 관리',
        concede: '컨시드',
        holecupPosition: '홀컵 위치',
        mulliganCount: '멀리건 횟수',
        swingPlate: '스윙 플레이트',
        distanceUnit: '거리 단위',
        greenPosition: '그린 위치',
        greenSpeed: '그린 스피드',
        windStrength: '바람 세기',
        puttingLine: '퍼팅라인',
        bestVideo: '베스트 영상',
        continuePutting: '퍼팅 이어하기',
        caddyVoice: '캐디 음성',
        noPuttMode: '퍼팅 생략',
        obTeeAndHazardTee: '오비 티, 해저드 티',
        on: '켜기',
        off: '끄기',
        saveChanges: '변경내용 저장',
        shotInfoLocation: '샷 정보 위치',
        side: '측면',
        bottom: '하단',
        greenHardness: '그린 경도',
        guideDistance: '공략 거리',
        maxScoreFactor: '홀 최대 타수',
      },
      shopDrivingRangeOptionSetting: {
        title: '연습장 옵션 관리',
        course: '코스',
        drivingRange1: 'KGOLF',
        drivingRange2: '장가계',
        drivingRange3: '센토사',
        drivingRange4: '히든캐슬',
        drivingRange5: 'KGOLF2',
        difficulty: '난이도',
        teeHeight: '티높이',
        windStrength: '바람 세기',
        distanceUnit: '거리 단위',
        swingPlate: '스윙 플레이트',
        ballTrajectory: '볼궤적',
        fixedCamera: '고정카메라',
        swingVideo: '스윙영상',
        on: '켜기',
        off: '끄기',
        saveChanges: '변경내용 저장',
      },
      shopClientRealTimeControlOptionSetting: {
        title: '타석 실시간 제어 옵션 기본값 설정',
        paymentType: '결제 방식',
        usageTimeSetting: '이용 시간 설정',
        usageModeSetting: '이용 모드 설정',
        noLimit: '제한 없음',
        stroke: '게임',
        drivingRange: '연습',
        usageContentSetting: '이용 컨텐츠 설정',
        availablePlayerCountSetting: '이용 가능 플레이어 인원 설정',
        holeType: '홀 타입',
        drivingRangeTime: '연습 시간',
        saveChanges: '변경내용 저장',
        peopleUnit: '명',
        none: '없음',
        minutes: '분',
      },
      accountInfoSetting: {
        accountInfo: '계정 정보',
        name: '이름',
        id: '아이디',
        password: '비밀번호',
        
        changePassword: '비밀번호 변경',
        newPasswordPlaceholder: '새로운 비밀번호를 입력해주세요.',
        cancel: '취소',
        submit: '변경',
        validation: '비밀번호는 숫자, 영어 소문자, 영어 대문자를 포함하여 4~12자로 설정할 수 있습니다.',
        successful: '계정의 비밀번호가 변경되었습니다.',
        fail: '비밀번호 변경에 실패했습니다.'
      },
      clientInfoSetting: {
        clientInfo: '클라이언트 비밀번호 변경',
        password: '비밀번호',
        changePassword: '비밀번호 변경',
        newPasswordPlaceholder: '새로운 비밀번호를 입력해주세요.',
        cancel: '취소',
        submit: '변경',
        validation: '비밀번호: 숫자 4자리',
        successful: '매장 전체 클라이언트의 비밀번호가 변경되었습니다.',
        fail: '비밀번호 변경에 실패했습니다.'
      },
    },
    scorecard: {
      title: '스코어카드',
      gameNumbers: '게임 번호',
      gameType: '게임 타입',
      courseName: '코스명',
      gameHoleType: '게임 홀 타입',
      shopName: '매장명',
      shopClientName: '타석명',
      startTime: '시작 시간',
      endTime: '종료 시간',
      concede: '컨시드',
      holeCupPosition: '홀컵위치',
      mulligan: '멀리건',
      greenPosition: '그린 위치',
      greenSpeed: '그린 스피드',
      swingPlate: '스윙 플레이트',
      windStrength: '바람 세기',
      distanceUnit: '거리 단위',
      puttingLine: '퍼팅 라인',
      bestVideo: '베스트 영상',
      caddyVoice: '캐디 목소리',
      whetherUseObTeeAndHazardTee: '오비티, 해저드티 사용 여부',
      use: '사용',
      unused: '미사용',
      stroke: '스트로크',
      newPerio: '신페리오',
      ranking: '순위',
      team: '팀',
      nickname: '닉네임',
      handicap: '핸디캡',
      close: '닫기',
      alertText1: '아직 진행중인 게임 라운드입니다.',
      grade: '등급',
      greenHardness: '그린 경도',
      guideDistance: '공략 거리',
      maxScoreFactor: '홀 최대 타수',
      on: '켜기',
      off: '끄기',
    },
    alert: {
      comingSoon: '준비중입니다.',
      unusualApproach: '비정상적인 접근입니다.',
      deletePaymentMethodSuccess: '결제 방법을 성공적으로 삭제하였습니다.',
      deletePaymentMethodFail: '결제 방법 삭제를 실패하였습니다.',
      shopRecurringPaymentCancelSuccess: '매장 정기결제 서비스 이용 취소가 완료되었습니다.',
      shopRecurringPaymentCancelFail: '매장 정기결제 서비스 이용 취소를 실패하였습니다.',
    },
    popup: {
      title: {
        sendMessage: '메시지 전송',
        scorecard: '스코어카드',
        addGuest: '게스트 추가',
        shotCancel: '샷 취소',
        extendedTime: '시간 연장',
        changeSetting: '설정 변경',
        courseSelection: '코스 설정',
        rankingCriteriaGameRoundCount: '게임 기록 많은 순이란?',
        rankingCriteriaBackCount: '백 카운트 방식이란?',
        shopTournamentOpenConfirm: '대회 개설 확인',
        shopTournamentModifyConfirm: '대회 수정 확인',

        deleteTournamentConfirm: '예정대회 삭제 안내',
        earlyEndTournamentConfirm: '대회 조기종료 안내',
        resetAwardsConfirm: '시상초기화 안내',
        awardRecipientsSelectionConfirm: '수상자 선정 확인',
        tournamentAwardAnnouncementConfirm: '수상자 발표 확인',
        contentsItemPayment: '콘텐츠 적용 안내',
        callNotification: '호출 알림',
      },
      button: {
        close: '닫기',
        cancel: '취소',
        confirm: '확인',
        announcement: '발표',
      },
    },
    agreement: {
      terms: '사업주 이용약관',
      privacy: '개인정보 처리방침',
      refund: '환불 규정',
      termsText:
          '스크린 골프 시스템 개발사이며 제조사인 케이골프와 케이골프 스크린 골프 시스템으로 영리 사업을 운영중인 사업주(점주) 당사자간에 시스템 이용에 대한 약관을 하기와 같이 정의한다.\n\n' +
          '제1조 (목적)\n' +
          '본 약관(이하 \'약관\'이라 칭함)은 이용자가 주식회사 케이골프 (이하 \'회사\'라 칭함)에서 제공하는 서비스 (스크린골프 서비스)의 이용 및 인터넷관련 서비스, 웹 및 모바일 서비스 이용과 관련하여 회사와 사업주의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.\n\n' +
          '제2조 (용어의 정의)\n' +
          '1. “사업주”란 회사가 서비스를 제공하기로 승인한 케이골프 제품을 설치하여 매장에서 영리를 목적으로 사업을 하는 사업자 대표를 말합니다.\n' +
          '2. “케이골프 매장”(이하 “사업장”이라 함)이란 사업주가 케이골프의 제품을 구입하고 회사가 서비스를 제공하기로 승인한 케이골프 제품 설치 매장을 말합니다.\n' +
          '3. “케이골프 제품”이란 케이골프에서 개발하고 생산한 스크린 골프 시스템을 의미합니다.\n' +
          '4. “이용자 고객”이란 사업장을 방문하여 케이골프 제품을 이용하고 사업장의 이용요금 정책에 따라 이용요금을 납부하는 케이골프 제품 이용 고객을 말합니다.\n' +
          '5. 과금이란 회사가 개발한 케이골프 제품의 소프트웨어를 사용하여 게임 및 유료 컨텐츠를 사용할 때 발생하는 이용료에 대한 부과를 의미합니다.\n' +
          '6. "케이골프 온라인 서비스"라 함은 이용자 고객이 사업장을 방문하여 케이골프 제품을 이용하는 모든 서비스(온라인 골프코스 이용, 이용자 고객 게임기록, 이벤트 진행 등)를 말합니다.\n' +
          '7. "케이골프 온라인 서비스 이용료"라 함은 이용자 고객이 "케이골프 온라인 골프코스 서비스"를 사용하는데 지불하는 비용을 말하며, 온라인 골프코스 이용 시 지불하는 형식으로 징수됩니다.\n' +
          '8. 매장 관리자란 회사가 사업주에게 제공하는 케이골프 제품을 온라인으로 관리하는 컴퓨터 프로그램을 의미합니다.\n\n' +
          '제3조 (게임 과금제의 운영)\n' +
          '1. 과금 방식은 아래와 같습니다.\n' +
          '  1) 케이골프 온라인 골프코스 서비스의 골프코스 이용료 과금은 게임당 과금으로 사업주에게 부과합니다.\n' +
          '  2) 골프코스 이용모드에서 1홀부터 18홀까지 한 홀 당 100원 부과 기준입니다.\n' +
          '  3) 이용자 고객의 사정 또는 매장 운영상 중간에 게임을 멈춘 경우 사용한 만큼의 홀을 기준으로 과금이 이루어집니다.\n' +
          '2. 이용 상품에 따른 과금은 아래와 같습니다.\n' +
          '  1) 연습장C 상품: 9홀 20개 코스만 이용 가능하며, 과금 면제 상품입니다.\n' +
          '  2) 결합형A·연습장B 상품: 모든 컨텐츠를 이용할 수 있으며, 코스 이용 시 홀 당 해당 인원만큼의 이용료를 과금합니다.\n' +
          '3. 결제 방법은 아래와 같습니다.\n' +
          '  1) 결제는 후불 자동이체 결제 방식을 원칙으로 하며 선결제 및 미납 결제 방식이 있습니다.\n' +
          '  2) 사업주는 매월 결제해야 하는 총금액을 한 번에 결제해야 합니다. 부분 납부는 불가합니다.\n' +
          '  3) 후불 자동이체: 지정 결제일에 이전달(1일~말일) 사용한 이용료를 자동 결제(오전/오후 총2회).\n' +
          '  4) 선결제: 지정 결제일 2일 전까지 계좌이체 또는 신용카드 결제.\n' +
          '  5) 미납결제: 지정 결제일 경과 후 사업주가 직접 결제.\n\n' +
          '제4조 (결제 방식·미수금 처리·이용상품 변경)\n' +
          '1. 계좌이체·신용카드 결제 2가지.\n' +
          '2. 미수금\n' +
          '  1) 결제일 이후 발생한 미납금은 즉시 서비스 이용 정지.\n' +
          '  2) 미수금 발생일로부터 매일 지연이자 발생(0.n%).\n' +
          '  3) 미수금 결제 시 서비스 복구.\n' +
          '3. 이용상품 변경은 매월 1일 반영.\n\n' +
          '제5조 (약관 외 준칙 및 관련 법령과의 관계)\n' +
          '1. 명시되지 않은 사항은 관련 법령·관습에 따릅니다.\n' +
          '2. 전자상거래법 등 소비자보호법령이 우선 적용됩니다.\n' +
          '3. 개별약관이 있는 경우 우선 적용됩니다.\n\n' +
          '제6조 (면책조항)\n' +
          '1. 천재지변·전쟁·통신사업자 중단 등 불가항력 시 책임 없음.\n' +
          '2. 설비 보수·교체 등으로 인한 손해 책임 없음.\n' +
          '3. 사업주 컴퓨터 오류·부실 정보 기재 등으로 인한 손해 책임 없음.\n' +
          '4. 기대수익 미달·자료 이용 손해 책임 없음.\n' +
          '5. 게시물 내용에 대한 사전심사 의무 없음.\n' +
          '6. 무료 서비스 관련 개인정보보호정책 위반 시를 제외하고 책임 없음.\n\n' +
          '제7조 (계약 철회 등)\n' +
          '1. 합의 철회·매매 시 사전 통지 및 미납금 정산 후 서비스 회수.\n' +
          '2. 지연 시 법정 이율로 지연이자 부과.\n' +
          '3. 일부 사용 시 해당 금액 및 비용 청구 가능.\n\n' +
          '제8조 (분쟁해결)\n' +
          '1. 피해보상처리부서 운영.\n' +
          '2. 불만·민원 우선 처리, 지연 시 사유·일정 통보.\n\n' +
          '제9조 (준거법·관할법원)\n' +
          '1. 대한민국 법 준거.\n' +
          '2. 민사소송법상 관할법원에 제소.',

      privacyText:
          '제1조 총칙\n' +
          '(주)케이골프(이하 \'회사\')는 이용자가 회사 매장관리자(https://kms.thekgolf.com)에서 제공하는 모든 서비스를 이용하며 제공하는 개인정보를 소중히 다룹니다. 관련 법령(통신비밀보호법, 정보통신망법 등)을 준수하며, 개인정보 보호정책을 통해 수집·이용 방식을 쉽게 안내합니다. 정책은 법령 및 사내 방침 변경 시 개정될 수 있습니다.\n\n' +
          '제2조 개인정보의 수집 항목·방법 및 이용 목적\n' +
          '가) 수집 항목\n' +
          '  1) 회원가입·서비스 제공: 이름, 아이디, 휴대폰, 주소, 이메일(탈퇴 시 삭제)\n' +
          '  2) 계좌 결제: 은행명, 계좌번호, 예금주명(5년)\n' +
          '  3) 가상계좌: 은행명, 입금자명(5년)\n' +
          '  4) 신용카드 결제: 카드사, 카드번호, 유효기간(5년)\n' +
          '  5) 거래 정보: IP, 쿠키, 접속로그, 이용기록(탈퇴 시 삭제)\n' +
          '  6) 이벤트·배송: 이름, 주소, 전화번호(목적 달성 후 파기)\n' +
          '  7) 판촉물: 이름, 주소, 전화번호(목적 달성 후 파기)\n\n' +
          '나) 이용 목적\n' +
          '  1) 계약 이행·요금정산\n' +
          '  2) 회원 관리·본인확인·불량 이용 방지·민원 처리\n' +
          '  3) 신규 서비스 개발·마케팅·통계·광고\n' +
          '  4) 서비스 장애 시 개별 고지\n\n' +
          '다) 보유 기간\n' +
          '  - 서비스 이용 기간 중 보유, 탈퇴·삭제 요청 시 파기\n' +
          '  - 이벤트 목적 달성 즉시 파기\n' +
          '  - 불량 회원 기록은 해지일로부터 1년 보관\n\n' +
          '라) 수집 방법\n' +
          '  - 홈페이지, 서면, 팩스, 전화, 게시판, 이메일, 이벤트, 쿠키·로그 수집 툴\n\n' +
          '제3조 개인정보 파기 절차 및 방법\n' +
          '가) 파기 절차: 목적 달성 후 내부 방침 및 법령에 따라 일정 기간 저장 후 파기\n' +
          '나) 파기 방법: 종이 문서는 분쇄·소각, 전자 파일은 복원이 불가능한 방식으로 삭제\n\n' +
          '제4조 개인정보의 공유·제공\n' +
          '원칙적으로 사전 동의 없이는 외부 제공 금지. 다만, \n' +
          '  - 이용자가 동의한 경우\n' +
          '  - 요금정산·서비스 위반·법령에 따른 수사기관 요구 등 예외 적용\n\n' +
          '제5조 처리 위탁\n' +
          '서비스 향상을 위해 외부 전문업체에 위탁, 위탁계약서에 법규 준수·책임 부담 명시\n' +
          '  - 위탁업무: 신용카드·계좌이체·SMS → 세틀뱅크\n\n' +
          '제6조 이용자 권리\n' +
          '이용자 및 법정대리인은 홈페이지에서 개인정보 조회·수정·삭제·탈퇴 요청 가능\n\n' +
          '제7조 동의 철회\n' +
          '회원가입 등 동의 철회는 서면·전화·이메일로 요청 시 즉시 처리\n\n' +
          '제8조 쿠키 운영\n' +
          '맞춤 서비스 제공을 위해 쿠키 사용. 브라우저 설정을 통해 허용·거부 가능. 거부 시 일부 서비스 이용 제한\n\n' +
          '제9조 보호 대책\n' +
          '  - 비밀번호 보호·백신·암호 알고리즘·침입차단시스템 적용\n' +
          '  - 담당자 한정 접근 및 주기적 교육 시행\n\n' +
          '제10조 어린이 정보 보호\n' +
          '만14세 미만은 법정 대리인 동의 필수\n\n' +
          '제11조 광고성 정보 전송\n' +
          '명시적 거부 의사 없이 광고 전송 금지, 전송 시 "광고" 문구 표기\n\n' +
          '제12조 책임자 연락처\n' +
          '개인정보 보호 책임자: 김학수(경영지원실) 1577-0564 / kimhs@thekgolf.com\n' +
          '제13조 개정\n' +
          '시행일자: 2021년 01월 02일',

      refundText:
          '본 규정은 (주)케이골프 및 가맹점에서 이용기간 또는 이용횟수를 정하여 선결제한 콘텐츠 이용권(예: 월정액권, 횟수권, 시즌권 등)에 대하여 소비자가 환불을 요청하는 경우 적용되며, 관련 법령 및 공정거래위원회 소비자분쟁해결기준, 그리고 업계 표준을 준용하여 운영됩니다.\n\n' +
          '제1조 (환불 사유 및 기준)\n' +
          '1. 소비자 귀책사유로 환불을 요청하는 경우\n' +
          '  1) 이용 시작 전:\n' +
          '    - 결제일로부터 7일 이내 환불 요청 시: 「전자상거래법」 제17조 및 제18조 제9항에 따라 전액 환불, 위약금·수수료 없음.\n' +
          '    - 7일 경과 후 환불 요청 시: 청약철회권 소멸, 이용 개시 후 기준 적용.\n' +
          '  2) 이용 시작 후:\n' +
          '    - 사용한 일수·횟수 해당 금액(정상 단가) 차감 후 잔액 환불.\n' +
          '    - 잔액에서 위약금(수수료) 10% 공제 후 환불.\n\n' +
          '2. 사업자 귀책사유로 환불 요청 시\n' +
          '  1) 이용 시작 전: 결제금액 전액 환불.\n' +
          '  2) 이용 시작 후: 미사용 잔여 기간·횟수 금액 전액 환불, 수수료 없음.\n\n' +
          '제2조 (환불 절차)\n' +
          '1. 서면 신청 또는 고객센터 요청 접수.\n' +
          '2. 결제일 기준 7일 이내 요청 시 즉시 전액 환불.\n' +
          '3. 이용 개시 후 요청 시, 사용분 차감·위약금 10% 공제 후 7영업일 이내 환불.\n' +
          '4. 가맹점→본사 전달 후 정산·환불 진행.\n\n' +
          '제3조 (환불 계산 예시)\n' +
          '예: 월정액권 100,000원·이용기간 30일\n' +
          '  - 10일 사용 후 해지 시\n' +
          '    · 사용금액: 10×3,333원 = 33,330원\n' +
          '    · 잔액: 100,000–33,330 = 66,670원\n' +
          '    · 위약금 10%: 6,667원\n' +
          '    · 환불금액: 60,003원(약 60,000원)\n\n' +
          '제4조 (고객 문의처)\n' +
          '환불 및 문의: 고객센터 +82-1577-0564\n\n' +
          '제5조 (법적 근거)\n' +
          '· 「전자상거래 등에서의 소비자보호에 관한 법률」 제17조·제18조\n' +
          '· 동법 시행령 제21조\n' +
          '· 「소비자분쟁해결기준」 (공정거래위원회 고시 제2023-14호)'
    },
    tournament: {
      list: {
        tournamentOpen: '대회 개설',
        tournamentId: '대회번호',
        title: '대회명',
        tournamentType: '개설타입',
        period: '기간',
        participantCount: '참가인원',
        courseCount: '코스개수',
        modify: '수정',
        etc: '기타',
        expires01: '새로운 대회 시스템이 7월 업데이트 예정입니다. 업데이트 이후부터는 대회 코스 최대 4개까지 선택 할 수 있습니다.',
        expires02: '업데이트 이전에 개설 되는 대회는 가급적 대회 종료 기간을 2024.09.15 내로 해주시길 바랍니다.',

        modifyPossibility: '수정가능',
        modifyImpossibility: '수정불가',
        listDelete: '삭제하기',
        earlyTermination: '조기종료',
        awarding: '시상하기',
        awardAnnouncement: '시상발표',
        awardRecipientsView: '시상내역',

        statusFilter: {
          all: '전체',
          proceeding: '진행중',
          expected: '예정',
          end: '종료',
        },

        popup: {
          deleteTournamentConfirm: {
            text1: '선택한 대회를 삭제 하시겠습니까?',
            text2: '※ 삭제된 대회는 복구되지 않습니다.',

            requestSuccess: '대회를 삭제 하였습니다.',
            requestFail: '대회 삭제를 실패 하였습니다. \n다시 시도하시기 바랍니다.',
          },
          earlyEndTournamentConfirm: {
            text1: '현재 진행중인 대회를 지금 시간을 기준으로 종료를 진행 하시겠습니까?',
            text2: '※ 대회를 종료하게되면, 더 이상 대회에 참가할 수 없습니다.',
            text3: '단, 현재 대회를 진행중인 사용자는 진행 할 수 있습니다.',

            requestSuccess: '대회를 조기종료 하였습니다.',
            requestFail: '대회 조기종료를 실패 하였습니다. \n다시 시도하시기 바랍니다.',
          },
        },
      },

      open: {
        tournamentTerm: '대회 약관',
        acceptTerms: '약관 동의',

        participatingStoresSettingAlert: '10개만 개설할 수 있습니다',
        participatingStoresSetting: '참가 매장 설정',
        addParticipatingStore: '참가 매장 추가',
        country: '국가',
        province: '시 / 도',
        city: '시 / 군 / 구',
        participatingStore: '참가 매장',

        basicSetting: '기본 설정',
        tournamentTitle: '대회명',
        tournamentTitlePlaceholder: '대회명을 입력해주세요. (한글 20자, 영문 40자 이내)',
        tournamentTitleInvalidMessage: '대회명은 40자 이내로 입력해주세요.',
        tournamentIntroduce: '대회 소개',
        tournamentIntroducePlaceholder: '간략한 대회 소개 글을 입력해주세요. (한글 100자, 영문 120자 이내)\n※입력하지 않을 경우, 공란으로 표시됩니다.',
        tournamentIntroduceInvalidMessage: '대회 소개는 120자 이내로 입력해주세요.',
        tournamentSummary: '대회 요강',
        tournamentParticipantTerms: '참가자 이용약관',
        tournamentSummaryDefaultValue:
        '케이골프 대회 이용약관\n' +
            '케이골프 대회는 케이골프본사, 케이골프의 매장주 혹은 매장주 모임의 대표가 주최가 되어 케이골프 스크린골프 게임의 프로그램과 장비를 이용하여 개설한 스크린골프 대회이다.\n' +
            '\n' +
            '제1조 참가자격\n' +
            '1. 비정상 회원을 제외하고 케이골프에 정상적으로 가입한 모든 회원은 참여 가능하다.\n' +
            '2. 비정상 회원 및 비 회원은 대회에 참여는 할 수 있으나 해당 라운드의 모든 기록은 랭킹에서 제외되며 집계 및 시상 대상에서도 제외된다. (비정상회원이라 함은 비 정상적인 이벤트 참여로 인해 제재 및 징계를 받은 회원 또는 상기내용에 상응하는 판정을 받은 아이디 보유 회원을 말한다.)\n' +
            '\n' +
            '제2조 참가방법\n' +
            '1. 전국 케이골프 매장에서 로그인 후 대회모드에 입장하여 대회목록에서 참가할 대회를 선택하여 라운드 하면 된다.\n' +
            '2. 매장의 라운드 비용 외의 별도 참가비는 없다\n' +
            '3. 본인 명의 1개 계정으로만 참여 가능하다. 타인 또는 복수의 계정으로 참여한 경우, 모든 계정의 참여가 무효 처리되며 시상 대상에서 제외된다.\n' +
            '\n' +
            '제3조 시상규정\n' +
            '1. 대회가 종료된 후 케이골프 앱을 통해 최종순위를 확인할 수 있으며 대회에서 정한 규정을 위반할 경우 시상에서 제외한다. (비회원 및 매장주는 시상에서 제외한다)\n' +
            '2. 시상 조건은 대회 주최측에 따라 상이할 수 있으며 공지에서 정한대로 시상이 이루어진다. 대회 진행 상황에 따라 시상내역은 변경될 수 있다.\n' +
            '3. 회원의 개인 연락처(휴대폰번호, 주소)가 정확하지 않을 경우 주최자의 판단에 따라 시상이 취소될 수 있다.\n' +
            '4. 매장에서 주최한 대회의 경우 본사 케이골프는 대회 조건 및 시상에 관여하지 않으며, 이에 대한 책임이 없다.\n' +
            '5. 합산 랭킹 산정 때 동점자가 발생할 경우, 최다 라운드 수, 백카운트, 마지막 라운드 시작 시간의 순서로 랭킹을 산정한다.\n' +
            '단, 다중 코스일 경우 백카운트 계산은 코스 랭킹에 등록된 라운드 의 합산 스코어로 계산한다.\n' +
            '\n' +
            '제4조 대회규정\n' +
            '1. 로그인한 경우 라운드 종료 후 스코어카드 제출 및 순위는 자동으로 이루어진다.\n' +
            '2. 18홀을 완주한 라운드만 인정한다. 라운드 미 완주 기록은 랭킹 및 시상에서 제외된다.\n' +
            '3. 카메라를 통해 본인 확인이 안 될 경우 실격으로 처리한다.\n' +
            '4. 라운드 룰은 케이골프 프로그램에 따르며 기본조건, 중도포기 등은 주최자에 의해 결정된다.\n' +
            '5. 프로그램상의 문제가 발생하거나 천재지변 등의 이유로 사전 공지된 매장대회가 취소되거나 진행중인 대회가 중단될 수 있다.\n' +
            '6. 서비스상의 문제가 아닌 매장상황(네트워크 불안정, 정전등)에 의해 문제가 발생하는 경우 그에 대한 책임과 해결은 주최자와 참가자가 협의한다.\n' +
            '7. 부득이한 상황의 문제 해결을 위해 지정된 멀리건수 만큼 사용 가능하며, 문제가 없는 경우 본인의지에 따라 사용할 수 있다.\n' +
            '8. 본인의 클럽을 사용할 수 있으며 본인 확인을 위해 주최측에서 임의로 영상을 확인하며 부정시에는 실격으로 처리한다. 또한, 컴퓨터 조작 등을 통해 발각시에도 부정으로 실격 처리한다.\n' +
            '9. 참가자는 사전 공지된 대회 조건을 반드시 숙지해야 하며, 이를 위반시 실격 처리될 수 있다.\n' +
            '\n' +
            '제5조 추가규정\n' +
            '1. 주최측의 지시에 불복 및 불 이행시 대회 참가가 제한될 수 있다.\n' +
            '2. 대회 종료 후에는 어떠한 문제제기도 인정되지 않는 것을 원칙으로 한다.\n' +
            '3. 시스템상의 에러를 사유로 참가자가 문제 제기 시 인식된 로그를 확인하여 인정여부를 결정한다.\n' +
            '4. 대회기간 저장된 동영상은 시상 검수용으로 사용되며, 일정기간이 지난 후 삭제한다.',
        tournamentThumbnail: '대회 썸네일',

        participationTarget: '참가 대상',
        participationTargetDescription: '성별 및 연령 구분 없이 모두 참가 가능',
        addParticipationTarget: '참가 대상 추가',
        participationTargetLimitType: '제한 구분',
        participationTargetName: '구분 이름',
        participationTargetFullName: '참가 대상 구분 이름',
        participationTargetGender: '성별',
        participationTargetBirthYearLimit: '출생년도 제한',
        participationTargetType: '참가 대상 타입',
        participationTargetMinimumBirthYear: '최소 출생년도',
        participationTargetMaximumBirthYear: '최대 출생년도',
        participationTargetBirthYearMessage1: '시작 년도 보다 이전 년도를 선택할 수 없습니다.',
        participationTargetBirthYearMessage2: '종료 년도 보다 이후 년도를 선택할 수 없습니다.',
        participationTargetTeeBoxTypeSetting: '티 위치 설정',

        participationGrade: '참가 등급',

        participationConditions: '참가 조건',
        participationConditionsDescription: '기존 대화 기록 상관없이 모두 참가 가능',
        addParticipationConditions: '참가조건 추가',
        participationConditionsLimitType: '제한 구분',
        participationConditionsTournamentList: '대회 목록',
        participationConditionsRankingsLitmit: '순위 제한',
        participationConditionType: '참가 조건 타입',
        participationConditionsTournamentTitlePlaceholder: '대회를 검색해주세요.',

        participationPeriod: '참가 기간',

        participatePublic: '참가 방식',
        participatePublicPlaceholder: '비밀번호(숫자4자리)',

        public: '공개',
        nondisclosure: '비공개',

        courseSetting: '코스 설정',
        courseCount: '코스 개수',
        courseCountUnit: '개',
        courseSelection: '코스 선택',
        courseNumber: 'No',
        courseTitle: '코스명',
        courseType: '코스 타입',
        courseDifficulty: '코스 난이도',
        greenDifficulty: '그린 난이도',
        longestHole: '롱기스트 홀',
        nearpinHole: '니어핀 홀',
        newPerio: '신페리오',
        outCourseHole: '전반 홀',
        inCourseHole: '후반 홀',

        gameSetting: '경기 설정',
        difficultyEasy: '쉬움',
        difficultyNormal: '보통',
        difficultyHard: '어려움',
        difficultyManual: '수동',
        courseStartOrder: '코스 시작 순서',
        courseStartValue1: '전반 홀 > 후반 홀',
        courseStartValue2: '후반 홀 > 전반 홀',
        userDifficulty: '사용자 난이도',
        swingPlate: '스윙 플레이트',
        mulliganCount: '멀리건 횟수',
        windPower: '바람 세기',
        holeCupPosition: '홀컵 위치',
        greenPosition: '그린 위치',
        concede: '컨시드',
        greenSpeed: '그린 빠르기',
        puttingLineCount: '퍼팅 라인 횟수',
        greenHardness : '그린 경도',
        teeBox: '티 위치',
        guideDistance: '공략 거리',

        participantHandicap: '참가자 핸디캡',
        calibrationGrade: '등급별 보정',
        userGrade: '회원등급',
        scoreCorrection: '스코어 보정',
        calibrationParticipant: '참가 대상별 보정',

        rankingCriteria: '랭킹 책정 기준',
        rankingCriteriaDescription1: '랭킹 책정 기준 설정이란?',
        rankingCriteriaDescription2: '동위 타수가 복수명 일 때, 해당 동위 타수의 랭킹 순서를 정하는 기준을 설정하는 것을 말합니다.',
        rankingCriteriaOne: '1순위',
        rankingCriteriaGameRoundCount: '게임 기록 많은 순',
        rankingCriteriaGameRoundCountButton: '게임 기록 많은 순이란?',
        rankingCriteriaGameRoundCountDescription: '스코어가 동점일 때 18홀 완료한 라운드 기록이 더 많은 플레이어가 상위 랭킹으로 등록 됩니다.',
        rankingCriteriaTwo: '2순위',
        rankingCriteriaOrderByGameRoundDesc: '백카운트 계산',
        rankingCriteriaCountbackDescription: '대회 각 코스별 등록된 라운드의 9홀 합, 6홀 합, 3홀 합, 마지막 홀 합 순서로 백카운트를 계산합니다. 이 백카운트 계산은 합산 랭킹에만 적용됩니다.',
        rankingCriteriaThree: '3순위',
        rankingCriteriaBackCount: '백 카운트 방식 사용',
        rankingCriteriaBackCountButton: '백 카운트 방식이란?',
        rankingCriteriaLastRoundStartTime: '마지막 라운드 시작 시간',
        rankingCriteriaLastRoundStartTimeDescription: '스코어, 게임 기록이 같을 때 18홀 완료한 마지막 라운드의 시작 시간 기준 가장 최근 순 플레이어가 상위 랭킹으로 등록 됩니다.',
        rankingCriteriaUse: '사용',
        rankingCriteriaUnused: '미사용',

        awardSetting: '시상 설정',
        addAward: '시상내역 추가',
        awardName: '시상 이름',
        awardNamePlaceholder: '시상 이름을 입력하세요.',
        awardGender: '성별 구분',
        awardGenderAll: '구분 없음',
        awardItem: '시상 항목',
        awardType: '시상 타입',
        awardCourse: '코스 구분',
        awardCourseTotal: '코스 종합',
        awardRankingType: '순위 구분',
        awardSingleRanking: '단일 순위',
        awardRanegeRanking: '범위 순위',
        awardRankingRange: '순위 범위',
        awardRankingPlaceholder: '순위를 입력하세요.',
        awardRankingRangeText1: '부터',
        awardRankingRangeText2: '까지',
        awardProduct: '시상 상품',
        awardProductPlaceholder: '시상 상품을 입력하세요.',

        whetherLimit: '제한 여부',
        unLimit: '제한 없음',
        delete: '삭제',
        all: '전체',
        yearUnit: '년',
        yearRangeText1: '부터',
        yearRangeText2: '까지',

        save: '저장',
        modify: '수정',

        navigation: {
          step1: '약관 동의',
          step2: '대회 설정',
          step3: '대회 개설',
        },

        popup: {
          courseSelection: {
            title: '대회 코스 선택',
            courseSearch: '코스 검색',
            courseSearchPlaceholder: '코스를 검색해주세요.',
            selection: '선택',
            save: '저장',
            cancel: '닫기',

            message1: '더이상 코스를 선택할 수 없습니다.',
            message2: '코스를 선택해주세요.',
          },
          rankingCriteriaGameRoundCount: {
            text1: '개최된 대회에 참가하여 해당 코스를 완료한 기록이 더 많은 사용자를 상위 랭킹에 등록하는 기능',
            cancel: '닫기',
          },
          rankingCriteriaBackCount: {
            text1: '사용자의 스코어를 전반홀/후반홀로 나눈다.',
            text2: '※ 여기서의 전반홀과 후반홀은 먼저 친 9개의 홀이 전반홀, 나중에친 9개의 홀이 후반홀이 된다.',
            text3: '홀번호가 10홀 이라고 해서 후반홀이 되지 않는다.',
            text4: '후반 (9홀) 총 스코어가 더 좋은 사용자의 랭킹이 더 높게 된다.',
            text5: '- 가장 마지막에 친 홀부터 9홀',
            text6: '후반 (6홀) 총 스코어가 더 좋은 사용자의 랭킹이 더 높게 된다.',
            text7: '- 가장 마지막에 친 홀부터 6홀',
            text8: '후반 (3홀) 총 스코어가 더 좋은 사용자의 랭킹이 더 높게 된다.',
            text9: '- 가장 마지막에 친 홀부터 3홀',
            text10: '가장 마지막에 친 홀의 스코어를 각각 비교하여 스코어가 더 좋은 사용자의 랭킹이 더 높게 책정 된다.',
            cancel: '닫기',
          },
          shopTournamentOpenConfirm: {
            text1: '작성된 내용으로 대회를 개설 하시겠습니까?',
            text2: '개설된 대회는 대회 리스트에서 조회 및 수정이 가능 합니다.',

            title: '이미 사용 중인 대회명입니다. 다른 대회명을 입력해주세요.',

            requestSuccess: '매장 대회 개설 완료되었습니다.',
            requestFail: '매장 대회 개설 중 오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.',
          },
          shopTournamentModifyConfirm: {
            text1: '작성된 내용으로 대회를 수정 하시겠습니까?',

            title: '이미 사용 중인 대회명입니다. 다른 대회명을 입력해주세요.',

            requestSuccess: '매장 대회 수정 완료되었습니다.',
            requestFail: '매장 대회 수정 중 오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.',
          },
        },

        alert: {
          message1: '참가 대상의 경우 최소 1개 이상 입력해야합니다.',
          message2: '핸디캡은 -99에서 99 사이 값만 입력 가능',
          message3: '대회 시작 시간은 현재 시간 기준 24시간 이후로 입력해야합니다.',
          message4: '대회 기간은 최대 1년까지만 설정 가능합니다.',
          message5: '코스설정이 비어있습니다. 코스설정에 내용을 기입하시기 바랍니다.',
          message6: '시상설정이 비어있습니다. 시상설정에 내용을 기입하시기 바랍니다.',
          message7: '시작순위를 작게하세요.',
          message8: '비밀번호는 숫자 4자리를 입력 해야 합니다.',
          message9: '설정한 순위에 오류가 있습니다. 확인 부탁드립니다.\n예: -1, 0 같은 숫자는 들어 갈 수 없습니다.',
          message10: '시상 이름을 입력해 주세요.',
          message11: '대회명을 입력 해주세요.',
          message12: '추가한 시상내역의 시상 항목을 설정 부탁드립니다.',
          message13: '코스 개수를 확인 후 코스를 선택해 주세요',
        },

        isParticipationGrade: '등급사용 여부',
        participationGradeText1:
          '등급 사용시 <img src="/images/icon/ui_icon_grade_0_0.png" alt="grade" class="icon_grade" /><img src="/images/icon/ui_icon_grade_1_0.png" alt="grade" class="icon_grade" /> 등급회원은 대회참가를 할 수 없습니다.',
        participationGradeSelectTitle: '참가대상',
        participationGradeSelectNoUse: '제한없음',
        participationGrade2: '브론즈',
        participationGrade3: '실버',
        participationGrade4: '골드',
        participationGrade5: '플래티넘',
        participationGrade6: '다이아몬드',
        participationKHandiText6: '-0.1 이하 (언더 유저)',
        participationKHandiText5: '0.0 이상 ~ +7.9 이하 (싱글 유저)',
        participationKHandiText4: '+8.0 이상 ~ +17.9 이하 (80 유저)',
        participationKHandiText3: '+18.0 이상 ~ 27.9 이하 (90타 유저)',
        participationKHandiText2: '+28.0 이상 ~  (100타 이상 유저)',
        participationGradeText6_3: 'Diamond 등급 전체 10% 이하',
        participationGradeText6_2: 'Diamond 등급 전체 10% 초과 ~ 30% 이하',
        participationGradeText6_1: 'Diamond 등급 전체 30% 초과 ~',
        participationGradeText5_3: '핸디 0.0 이상 ~ 2.0 이하',
        participationGradeText5_2: '핸디 2.1 이상 ~ 5.0 이하',
        participationGradeText5_1: '핸디 5.1 이상 ~ 7.9 이하',
        participationGradeText4_3: '핸디 8.0 이상 ~ 10.0 이하',
        participationGradeText4_2: '핸디 10.1 이상 ~ 14.0 이하',
        participationGradeText4_1: '핸디 14.1 이상 ~ 17.9 이하',
        participationGradeText3_3: '핸디 18.0 이상 ~ 20.0 이하',
        participationGradeText3_2: '핸디 20.1 이상 ~ 24.0 이하',
        participationGradeText3_1: '핸디 24.1 이상 ~ 27.9 이하',
        participationGradeText2_3: '핸디 28.0 이상 ~ 38.0 이하',
        participationGradeText2_2: '핸디 38.1이상 ~ 48.0 이하',
        participationGradeText2_1: '핸디 48.1이상 ~',
        calibration: '보정치',
        kHandi: 'K Handi',
        criteria: '기준',
        notAllowed: '참가불가',
      },

      details: {
        tab: {
          summary: '대회 요강',
          information: '대회 정보',
          ranking: '대회 랭킹',
          award: '대회 시상',
          awardHistory: '시상 내역',
          participantTerms: '참가자 이용약관',
          participatingStoresList: '참가 매장 리스트',
        },

        information: {
          introduce: '대회 소개',

          tournamentPeriod: '대회 기간',
          participatePublic:'참가 방식',

          participationTarget: '참가 대상',
          participationNoLimit: '제한 없음',
          participationTargetName: '구분 이름',
          participationTargetFullName: '참가 대상 구분 이름',
          participationTargetMinimumBirthYear: '최소 출생년도',
          participationTargetMaximumBirthYear: '최대 출생년도',
          participationTargetTeeBoxSetting: '티 위치 설정',

          participationGrade: '참가 등급',
          gradeParticipationAvailability: '참가 가능 여부',
          participationPossible: '참가 가능',
          unableParticipate: '참가 불가능',

          participationConditions: '참가 조건',
          participationConditionTournamentName: '대회명',
          participationConditionRankingLimit: '순위 제한',

          tournamentCourse: '대회 코스',
          courseNumber: '코스 번호',
          courseName: '코스 이름',
          courseLongest: '롱기스트',
          courseNearpin: '니어핀',
          sinperioExclusionHall: '신페리오 제외 홀',

          userDifficulty: '사용자 난이도',
          swingPlate: '스윙 플레이트',
          mulliganCount: '멀리건 횟수',
          windPower: '바람 세기',
          holeCupPosition: '홀컵 위치',
          greenPosition: '그린 위치',
          concede: '컨시드',
          greenSpeed: '그린 빠르기',
          puttingLineCount: '퍼팅 라인 횟수',
          teeBox: '티 위치',
          greenHardness: '그린 경도',
          calibrationGrade: '등급별 보정',
          guideDistance: '공략 거리',

          calibrationParticipant: '참가 대상별 보정',

          awardItem: '시상 항목',
          awardName: '시상 이름',
          awardType: '시상 타입',
          awardCourse: '코스 구분',
          awardRankingType: '순위 구분',
          awardSingleRanking: '단일 순위',
          awardRanegeRanking: '범위 순위',
          awardRankingRange: '순위 범위',
          awardRankingUnit: '등',
          awardProduct: '시상 상품',
          awardNone: '없음',
          awardAll: '전체',

          awardAnnouncement: '수상자 발표하기',
          scoreCorrection: '스코어 보정',
          genderNoLimit: '무관',
          participationGradeTitle: '참가대상 및 보정정보',
        },

        participatingStoresList: {
          country: '국가',
          province: '시 / 도',
          city: '시 / 군 / 구',
          participatingStore: '참가 매장',
          all: '전체',
        },

        ranking: {
          courseTotalScore: '총 스코어',
          searchTextBoxPlaceholder: '닉네임을 입력해주세요.',

          allRanking: '전체 순위',
          allRankingOption1: '순위 높은순',
          allRankingOption2: '순위 낮은순',
          allRankingOptionReset: '초기화',

          genderRanking: '성별 순위',
          genderRankingOption1: '여성만',
          genderRankingOption2: '남성만',
          genderRankingOptionAll: '전체',

          nickname: '닉네임',
          participationCount: '참가 횟수',
          teeBoxLocation: '티박스 위치',
          totalDistance: '비거리 (m)',
          remainDistance: '남은거리 (m)',
          recordTime: '달성 시간',
          lastRoundStartTime: '마지막 라운드 시작 시간',
          newPerioScoreRecord: '12홀 성적',
          finalScore: '최종 스코어',
          birdieCount: '버디 횟수',
          eagleCount: '이글 횟수',
          courseName: '코스 이름',
          holeNumber: '홀 번호',
          courseDistance: '전장 거리',
          totalParticipationCount: '총 참가 횟수',
          gradeRankingOption1: '높은순',
          gradeRankingOption2: '낮은순',
          handicap: '핸디캡',
        },

        awardRanking: {
          allChoice: '전체 선택',
          awardConfirmation: '시상 확정',
          resetAwards: '시상 초기화',
          awardRecipientsSelection: '수상자 선정',

          courseScore: '코스 스코어',
          handicap: '핸디캡',
          additionalHandicap: '추가 핸디캡',
          adjustmentResult: '조정 결과',
          adjustmentSynthesis: '조정 종합',
          finalScore: '최종 스코어',
          courseOverall: '코스 종합',
          swingVideo: '스윙 영상',
          videoPlay: '영상 재생',

          alert: {
            message1: '추가 핸디캡은 -99에서 99사이의 숫자만 입력 가능',
          },
        },

        awardHistory: {
          rankingUnit: '위',

          ranking: '순위',
          nickname: '닉네임',
          record: '기록',
          recordTime: '달성 시간',
          totalParticipationCount: '총 참가 횟수',
          courseName: '코스 이름',
          holeNumber: '홀 번호',
        },

        course: '코스',
        summation: '합산',
        gender: '성별',
        grade: '참가시 등급',
        startGrade: '시작 등급',
        finalGrade: '최종 등급',
        handicapGrade: '등급',
        storeUse: '이용 매장',
        public: '공개',
        nondisclosure: '비공개',

        alert: {
          message1: '대회 종료 후 24시간이 지나야 접근 가능',
          message2: '대회 수상자 선정 후 시상내역 보기 가능',
        },

        popup: {
          resetTournamentAwardsConfirm: {
            text1: '시상 초기화를 진행하시겠습니까?',
            text2: '시상 초기화를 진행하면, 현재 등록된 추가 핸디캡 및 시상 확정 내역이 모두 초기화 됩니다.',

            requestSuccess: '시상내역을 모두 초기화 하였습니다.',
            requestFail: '시상내역 초기화에 실패 하였습니다. \n다시 시도하시기 바랍니다.',
          },

          tournamentAwardRecipientsSelectionConfirm: {
            text1: '현재 등록된 시상확정을 기준으로 수상자를 선정 하시겠습니까?',
            text2: '등록된 내용은 시상내역 페이지에서 확인 할 수 있습니다.',
            text3: '수상자 선정 후에는 순위 조정을 할 수 없습니다.',
            text4: '다시 조정을 하기 위해서는 시상 초기화를 한 후에 순위 조정을 할 수 있습니다.',

            requestSuccess: '수상자 선정이 완료 되었습니다. \n수상자는 시상내역 페이지에서 확인 할 수 있습니다.',
            requestFail: '수상자 선정이 실패 되었습니다. \n다시 시도해 주시기 바랍니다.',
          },

          tournamentAwardAnnouncementConfirm: {
            text1: '수상자를 발표하면 더 이상 수상자를 수정 할수 없습니다.',
            text2: '수상자 발표를 진행 하시겠습니까?',

            requestSuccess: '수상자 발표가 완료 되었습니다.',
            requestFail: '수상자 발표에 실패 하였습니다.',
          },
        },
      },

      awardItem: {
        Score: '스코어',
        Longest: '롱기스트',
        Nearpin: '니어핀',
        HoleInOne: '홀인원',
        CourseRoundPlayCount: '라운딩 횟수',
      },
      awardType: {
        Stroke: '스트로크',
        NewPerio: '신페리오',
        BirdieCount: '버디 횟수',
        EagleCount: '이글 횟수',
      },
    },
    control: {
      image: {
        delete: '삭제하기',
        fileSelect: '파일선택',
      },
    },
    contentsItem: {
      info: {
        prevItem: '이전 구매 콘텐츠 정보',
        prevItemText: '더 이상 구매할 수 없는 콘텐츠 이용권 입니다. <br/>구매를 원하실 경우 서비스 운영팀으로 문의 주세요.',
        itemText: '본 상품은 구매 후 자동으로 적용됩니다.',
        alertMsgTitle: '콘텐츠 사용 안내',
        alertMsgSubTitle: '사용중인 콘텐츠',
        alertMsgUser: '안녕하세요. {user}님.',
        paymentMsg: '구매하신 콘텐츠 이용권이 다음과 같이 적용되었습니다.',
        paymentTitle: '결제 수단 선택',
      },
      button: {
        payment: '구매하러 가기',
        purchase: '구매하기',
        rePurchase: '재 구매하기',
        creditCard: '신용카드',
        cash: '계좌이체',
        paypal: 'PayPal',
      },
      shopSupplyItem: {
        salesCode:'자재코드'
      },
      1010110110: {
        title: '콘텐츠 이용권(기간제)',
        icon: '/itemImage/ui_icon_period.png',
        unit: 'DAYS',
        itemInfo: '매장 기기',
        itemDescription: '{count}일 동안 게임 콘텐츠를 사용 할 수 있는 콘텐츠 이용권(기간제)입니다.',
        itemPayment: '{count}일이 추가되어 {newCount}일 만큼 콘텐츠 사용이 가능합니다.',
        alertMsg: '매장에서 사용중인 콘텐츠 이용권(기간제)가 {count}일 후에 모두 소진될 예정입니다. 원활한 콘텐츠 사용을 위해 콘텐츠 이용권(기간제)을 구매해 주세요.',
        alertMsgNone: '매장에서 사용중인 콘텐츠 이용권(기간제)가 모두 소진되었습니다. \n콘텐츠 이용권(기간제)가 없을 경우 새로운 게임을 진행 할 수 없습니다. \nShop으로 이동하여 콘텐츠 이용권(기간제)을 구매해 주세요.',
      },
      1010120110: {
        title: '콘텐츠 이용권(홀)',
        icon: '/itemImage/ui_icon_round.png',
        unit: 'HOLE',
        itemDescription: '{count}홀 회수만큼 게임 콘텐츠를 사용 할 수 있는 콘텐츠 이용권(홀)입니다.',
        itemPayment: '{count}홀이 추가되어 {newCount}홀 만큼 콘텐츠 사용이 가능합니다.',
        alertMsg: '매장에서 사용중인 콘텐츠 이용권(홀)이 {count}홀 남았습니다. 원활한 콘텐츠 사용을 위해 콘텐츠 이용권(홀)을 구매해 주세요.',
        alertMsgNone: '매장에서 사용중인 콘텐츠 이용권(홀)이 {count}홀 남았습니다. \n콘텐츠 이용권(홀)이 {round}홀 이하가 될 경우 새로운 게임을 진행 할 수 없게 됩니다. \nShop으로 이동하여 콘텐츠 이용권(홀)을 구매해 주세요.',
      },
      alertMsg: {
        all: '매장에서 사용중인 콘텐츠 이용권(기간제)가 {day}일, 콘텐츠 이용권(홀)이 {count}홀 플레이 후 모두 소진될 예정이오니 원활한 콘텐츠 사용을 위해 콘텐츠 이용권(기간제), 콘텐츠 이용권(홀)을 구매해주세요.',
        allNone: '매장에서 사용중인 콘텐츠 이용권(기간제)이 {day}일, 콘텐츠 이용권(홀)이 {round}홀 이하가 되었습니다. \n콘텐츠  이용권이 부족할 경우 새로운 게임을 진행 할 수 없습니다. \nShop으로 이동하여 콘텐츠 이용권을 구매해 주세요.',
      },
      // 소모품 구매
      20111011041012: {
        title: '기타 소모품 LAN 케이블',
        icon: '/itemImage/KGFCAB001001.jpg',
        unit: '개(ea)',
        itemDescription: '해당 상품은 CAT5E 규격의 센서연결용 케이블(20M)입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다.',
        salesCode:'100155',
      },
      51101511111011: {
        title: '매트 BGS형 스탠스 매트',
        icon: '/itemImage/KGFMAT001012.jpg',
        unit: '개(ea)',
        itemDescription: '룸형(국방색 , 고무매트포함,사이즈 1100x1300) 상품입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다.',
        salesCode:'100061',
      },
      51101511111012: {
        title: '매트 BGS형 (좌/우)페어웨이세트   ',
        icon: '/itemImage/KGFMAT001013.jpg  ',
        unit: '세트(set)  ',
        itemDescription: '룸형으로 페어웨이,러프,벙커메트 및 고무판 포함 (사이즈 600x1300)된 상품입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다.',
        salesCode:'100062',
      },
      51101511111013: {
        title: '매트 BGS형 교체형 페어웨이 및 조인트 ⊏ 자형 세트',
        icon: '/itemImage/KGFMAT002015.jpg',
        unit: '개(ea)',
        itemDescription: '해당 상품은 러셀잔디, 러프, 벙커가 포함되지 않습니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다.',
        salesCode:'100081',
      },
      51101511111014: {
        title: '매트 BGS형 페어웨이 매트',
        icon: '/itemImage/KGFMAT002016.jpg',
        unit: '개(ea)',
        itemDescription: '일자 잔디분리형(일자 상판투톤, 사이즈:370x1300) 상품 입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다."  ',
        salesCode:'100082',
      },
      51101511111015: {
        title: '매트 BGS형 교체형 직모페어웨이 우타고무판(성웅)',
        icon: '/itemImage/700004.jpg',
        unit: '개(ea)',
        itemDescription: '해당상품은 ⊏ 모형 고무 하판(사이즈: 600x1300) 입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다.',
        salesCode:'100073',
      },
      51101511111016: {
        title: '매트 BGS형 러프 매트',
        icon: '/itemImage/KGFMAT002001.jpg',
        unit: '개(ea)',
        itemDescription: '러프매트 교체형(사이즈: 400x230) 상품입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다.',
        salesCode:'100067',
      },
      51101511111017: {
        title: '매트 BGS형 회색 벙커 매트',
        icon: '/itemImage/KGFMAT002017.jpg',
        unit: '개(ea)',
        itemDescription: '해당 상품은 벙커매트 교체형(회색, 사이즈: 400x230)입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다.',
        salesCode:'100083',
      },
      51101511111018: {
        title: '매트 BGS형 은색 브러쉬 벙커 매트',
        icon: '/itemImage/KGFMAT001011.jpg',
        unit: '개(ea)',
        itemDescription: '해당 상품은 은색 브러시 벙커매트 교체형(사이즈: 400x230) 입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다.',
        salesCode:'100060',
      },
      51101512111011: {
        title: '매트 KDR형 스탠스매트',
        icon: '/itemImage/KGFMAT001015.jpg',
        unit: '개(ea)',
        itemDescription: '연습장용(국방색,고무매트포함,사이즈 1000x1000) 상품입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다.',
        salesCode:'100064',
      },
      51101512111012: {
        title: '매트 KDR형 페어웨이교체형',
        icon: '/itemImage/KGFMAT001017.jpg',
        unit: '개(ea)',
        itemDescription: '연습장용(국방색, 매트밑 고무포함,사이즈 500x1000) 상품입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다.',
        salesCode:'100066',
      },
      51101513111011: {
        title: '오토 티업기 155우타매립오토티업기',
        icon: '/itemImage/100175.jpg',
        unit: '개(ea)',
        itemDescription: '해당 상품은 전체 교체를 위한 일체형(매립 키패드 포함) 상품입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다.',
        salesCode:'100175',
      },
      51101514111012: {
        title: '기타 소모품 고무티(오토티용,조은정밀)',
        icon: '/itemImage/100187.jpg',
        unit: '개(ea)',
        itemDescription: '해당 상품은 조은정밀 제작 오토티용 고무티 상품입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다  ',
        salesCode:'100187',
      },
      51101514111013: {
        title: '기타 소모품 고무티(플레이트용,조은정밀)',
        icon: '/itemImage/100188.jpg',
        unit: '개(ea)',
        itemDescription: '해당 상품은 조은 정밀 제작 플레이트용 고무티 상품입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다.',
        salesCode:'100188',
      },
      51101517700001: {
        title: 'Mat BGS Type Fairway Mat',
        icon: '/itemImage/700001.jpg',
        unit: 'ea',
        itemDescription: '투톤 잔디, 벨크로 바닥, 사이즈 370x1040mm의 페어웨이 매트입니다.<br />* 주문 현황은 결제 관리 메뉴에서 확인하실 수 있습니다.',
        salesCode: '700001',
      },
      51101517700002: {
        title: 'Mat BGS Type Fairway Extension Mat 1',
        icon: '/itemImage/700002.jpg',
        unit: 'ea',
        itemDescription: '페어웨이 매트 확장 패널. 하단 벨크로. 230x240mm.<br />* 주문 현황은 결제 관리 메뉴에서 확인하실 수 있습니다..',
        salesCode: '700002',
      },
      51101517700003: {
        title: 'Mat BGS Type Fairway Extension Mat 2',
        icon: '/itemImage/700003.jpg',
        unit: 'ea',
        itemDescription: '페어웨이 매트 확장 패널. 벨크로 바닥. 260x600mm.<br />* 주문 현황은 결제 관리 메뉴에서 확인하실 수 있습니다.',
        salesCode: '700003',
      },
      51101517700004: {
        title: 'Mat BGS Type Fairway Mat Rubber base',
        icon: '/itemImage/700004.jpg',
        unit: 'ea',
        itemDescription: '페어웨이 세트용 고무 받침대, 벨크로 상단, 사이즈 600x1300mm.<br />* 주문 현황은 결제 관리 메뉴에서 확인하실 수 있습니다.',
        salesCode: '700004',
      },
      51101517700005: {
        title: 'Mat BGS Type Rough Mat',
        icon: '/itemImage/700005.jpg',
        unit: 'ea',
        itemDescription: '러프 매트, 벨크로 바닥, 사이즈 400x230mm.<br />* 주문 현황은 결제 관리 메뉴에서 확인하실 수 있습니다.',
        salesCode: '700005',
      },
      51101517700007: {
        title: 'Mat BGS Type Stance Mat',
        icon: '/itemImage/700007.jpg',
        unit: 'ea',
        itemDescription: '스탠스 매트(고무 바닥), 사이즈 1100x1300mm.<br />* 주문 현황은 결제 관리 메뉴에서 확인하실 수 있습니다.',
        salesCode: '700007',
      },
      51101517700009: {
        title: 'Mat BGS Type Fairway Set (Right Hand)',
        icon: '/itemImage/700009.jpg',
        unit: 'ea',
        itemDescription: '페어웨이, 러프, 벙커, 고무 받침대가 있는 오른손잡이용 올인원 매트 세트, 사이즈 600x1300mm.<br />* 주문 현황은 결제 관리 메뉴에서 확인하실 수 있습니다.',
        salesCode: '700009',
      },
      51101517700010: {
        title: 'Mat BGS Type Fairway Set (Left Hand)',
        icon: '/itemImage/700010.jpg',
        unit: 'ea',
        itemDescription: '페어웨이, 러프, 벙커, 고무 바닥이 있는 왼손잡이용 올인원 매트 세트, 사이즈 600x1300mm.<br />* 주문 현황은 결제 관리 메뉴에서 확인하실 수 있습니다.',
        salesCode: '700010',
      },
      51101517100175: {
        title: 'Auto Tee Type Auto Tee up System(Right Hand)',
        icon: '/itemImage/100175.jpg',
        unit: 'ea',
        itemDescription: '오른손잡이용 내장형 자동 티업 시스템 세트, 통합형 플로어 키패드 포함.<br />* 주문 현황은 결제 관리 메뉴에서 확인하실 수 있습니다.',
        salesCode: '100175',
      },
      51101517100176: {
        title: 'Auto Tee Type Auto Tee up System (Left Hand)',
        icon: '/itemImage/100176.jpg',
        unit: 'ea',
        itemDescription: '왼손잡이용 내장형 자동 티업 시스템 세트, 통합형 플로어 키패드 포함.<br />* 주문 현황은 결제 관리 메뉴에서 확인하실 수 있습니다.',
        salesCode: '100176',
      },
      51101517100222: {
        title: 'Mat BGS Type Bunker Mat',
        icon: '/itemImage/100222.jpg',
        unit: 'ea',
        itemDescription: '브러시 벙커 매트(스틸 바닥면, 벨크로 부착, 사이즈 400x230mm)<br />* 주문 현황은 결제 관리 메뉴에서 확인하실 수 있습니다.',
        salesCode: '100222',
      },
      51101514111011: {
        title: '기타 소모품 고무티(씨티앤지)',
        icon: '/itemImage/100186.jpg',
        unit: '개(ea)',
        itemDescription: '해당 상품은 시티앤지 제작 고무티 상품입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다.',
        salesCode:'100186',
      },
      51101514111014: {
        title: '기타 소모품 뷰센서마킹볼(넥센, 4DOT ball, 300ea)   ',
        icon: '/itemImage/KGFBAL001001.jpg',
        unit: '박스(box)',
        itemDescription: '해당 상품은 1박스(300ea) 상품입니다.<br />* 결제 관리 메뉴에서 주문 상태를 확인할 수 있습니다.',
        salesCode:'100166',
      },

    },
  },
};
